import type { MouseEvent } from 'react'
import { Link, useLocation } from 'react-router-dom'

import { Icon, type IconName } from '../../atoms'

export interface NavLinkProps {
  to: string
  label: string
  icon?: IconName
  exact?: boolean
  className?: string
  /** Runs before navigating; call `event.preventDefault()` inside to cancel. */
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void
}

export function NavLink({ to, label, icon, exact = false, className = '', onClick }: NavLinkProps) {
  const location = useLocation()

  const isActive = exact ? location.pathname === to : location.pathname.startsWith(to)

  return (
    <Link
      to={to}
      onClick={onClick}
      className={`
        flex items-center gap-2 px-3 py-1.5 text-sm font-medium transition-all duration-150
        ${isActive ? 'rounded text-white' : 'text-white/65 hover:text-white'}
        ${className}
      `}
      style={isActive ? { backgroundColor: 'var(--brand-primary)' } : undefined}
    >
      {icon && <Icon name={icon} size="sm" />}
      <span>{label}</span>
    </Link>
  )
}
